import Head from 'next/head'

interface SEOProps {
  title?: string
  description?: string
  image?: string
}

const SEO = ({ title, description, image }: SEOProps) => {
  return (
    <Head>
      <title>{`${process.env.APP_NAME}${title ? title : ''}`}</title>
      <meta
        itemProp="name"
        content={`${process.env.APP_NAME}${title ? title : ''}`}
      />
      {description && <meta name="description" content={description} />}
      {description && <meta itemProp="description" content={description} />}
      {image && <meta itemProp="image" content={image} />}
    </Head>
  )
}

export default SEO
